module.exports = __webpack_public_path__ + "static/media/logo-xs.0179e83e.svg";